var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurePaymentFill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "secure-payment-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3412 3.3335L30.505 7.13468C31.2007 7.35211 31.6745 7.99651 31.6745 8.72548V11.6668H35.0078C35.9283 11.6668 36.6745 12.413 36.6745 13.3335V16.6668H15.0078V13.3335C15.0078 12.413 15.754 11.6668 16.6745 11.6668H28.3412V9.95016L18.3412 6.8235L8.34115 9.95016V22.2908C8.34115 24.3657 9.30645 26.3142 10.9385 27.5715L11.2522 27.799L18.3412 32.6318L24.6445 28.3335H16.6745C15.754 28.3335 15.0078 27.5873 15.0078 26.6668V20.0002H36.6745V26.6668C36.6745 27.5873 35.9283 28.3335 35.0078 28.3335L29.641 28.3353C28.9967 29.1848 28.2123 29.9365 27.3078 30.5532L18.3412 36.6668L9.37445 30.5532C6.6424 28.6903 5.00781 25.5975 5.00781 22.2908V8.72548C5.00781 7.99651 5.48156 7.35211 6.17736 7.13468L18.3412 3.3335Z",
    fill: "#006B5D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurePaymentFill);
export default __webpack_public_path__ + "static/media/secure-payment-fill.233d959ce3cd80d8a56b6b8d39a5596a.svg";
export { ForwardRef as ReactComponent };